import Link from "next/link";

export default function Neulogovan() {
    return (
        <div>
            <img
                src="/blur-utisak.jpeg"
                alt="neulogovan"
                className="hidden md:block"
            />
            <img
                src="/blur-utisak-mob.jpeg"
                alt="neulogovan"
                className="md:hidden"
            />
            <div className="text-center mt-12 mb-12 bg-blue-superlight py-2 px-4 max-w-screen-md m-auto">
                <Link
                    href={`/auth/signin?redirect=${
                        typeof window !== "undefined"
                            ? window.location.href
                            : null
                    }`}
                >
                    <a className="underline font-medium">
                        Prijavi se da vidiš sve utiske.
                    </a>
                </Link>
            </div>
        </div>
    );
}
